import type { AdminGameModule } from './types';
import { wordClashAdminModule } from '@games/word-clash/admin';

/**
 * Built-in admin game registration (#817) — the admin twin of
 * `framework/server/src/games/index.ts`, and the ONLY framework admin file
 * that imports a game. A game with admin pages adds ONE line here; a game
 * without any (Backgammon, Batak, King, 101 Okey) is simply absent and the
 * console renders the platform pages alone.
 */
export const ADMIN_GAME_MODULES: readonly AdminGameModule[] = [wordClashAdminModule];
